import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  ElementRef,
  inject,
  OnInit,
  viewChild,
} from '@angular/core';

import { Desktop } from 'src/app/core/api/models/desktop';
import { AddApiUrlBeforePathPipe } from 'src/app/core/pipes/add-api-url-before-path.pipe';
import { AppStateService } from 'src/app/core/services/app-state.service';
import { AppConfigService } from 'src/app/core/services/config.service';
import { TranslationModule } from 'src/app/i18n/translation.module';
import { ClientDataInitializerService } from '../../../core/services/authentication/client-data-initializer.service';
import { AppIntroService } from './app-intro.service';
@Component({
  selector: 'app-intro',
  imports: [CommonModule, TranslationModule, AddApiUrlBeforePathPipe],
  templateUrl: './app-intro.component.html',
  styleUrls: ['./app-intro.component.scss'],
})
export class AppIntroComponent implements OnInit {
  private appIntroService = inject(AppIntroService);
  private clientDataService = inject(ClientDataInitializerService);
  private appStateService = inject(AppStateService);

  readonly splashScreen = viewChild<ElementRef>('splashScreen');
  isOwnerPanel = false;
  agentName: string;
  desktop: Desktop;
  appUrl: string = AppConfigService.config.appUrl;
  backgroundImagePath: string;

  readonly agentLogo = computed(() => {
    const clientData = this.clientDataService.getCurrentClientData;
    return this.appStateService.currentThemeMode() === 'dark' &&
      clientData?.darkLogoSrc
      ? clientData.darkLogoSrc
      : clientData?.agentLogo;
  });

  get Desktop() {
    return Desktop;
  }

  ngOnInit() {
    this.appIntroService.init(this.splashScreen());

    const clientData = this.clientDataService.getCurrentClientData;
    this.agentName = clientData?.name;
    this.backgroundImagePath = clientData?.backgroundImagePath;

    this.desktop = AppStateService.appTheme;
  }

  onRefresh() {
    location.reload();
  }
}
